import React, { useEffect } from "react";
import { useRef } from "react";

import GlobalStyles from "../GlobalStyles";

import Button from "../components/Button";

import TextField from "@mui/material/TextField";

import ChatMode from "../Chat";

import { colors } from "../variables";
import { styles } from "./styles";

const Main = (props) => {
  const [chatMode, setChatMode] = React.useState(false);
  const [prompt, setPrompt] = React.useState("");
  const [password, setPassword] = React.useState("");

  const passwordInput = useRef(null);

  const REACT_APP_VERSION = "0.0.3 (fix typing)";

  useEffect(() => {
    passwordInput.current.addEventListener("keydown", (event) => {
      event.stopPropagation();
    });
  }, []);

  const InstructionMode = (props) => {
    return (
      <div style={styles.instructions}>
        <div style={styles.stack}>
          <div style={styles.instructionsTitle}>
            <h3>{props.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: props.description }} />
          </div>
          <div>
            <Button
              className={styles.button}
              onClick={() => {
                setChatMode(true);
                setPrompt(props.prompt);
                console.log("prompt...: ", props.prompt);
              }}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const Widget = (props) => {
    return (
      <div style={styles.appContainer}>
        <GlobalStyles />

        {chatMode ? (
          <ChatMode prompt={prompt} password={password} />
        ) : (
          <InstructionMode
            title={props.title}
            description={props.description}
            prompt={props.prompt}
          />
        )}
        <div style={styles.caveat}>Powered by OpenAI (so blame them!)</div>
      </div>
    );
  };

  const Password = (props) => {
    return (
      <div style={styles.passwordContainer}>
        <GlobalStyles />
        <span style={{ fontSize: "0.5rem", textAlign: "left" }}>
          wc-orm-chat v {REACT_APP_VERSION}
        </span>
        <p>Please enter the secret password to access this experience</p>
        <TextField
          ref={passwordInput}
          id="outlined-basic"
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            e.stopPropagation();
          }}
          style={{ width: "60%" }}
          InputLabelProps={{
            sx: {
              typography: {
                fontFamily: "Gilroy",
                fontSize: "1.2rem",
                top: "-.2em",
                paddingRight: ".75em",
                backgroundColor: colors.grayBackground,
              },
            },
          }}
          InputProps={{
            sx: {
              typography: { fontFamily: "Gilroy" },
            },
          }}
        />
      </div>
    );
  };

  return password == "tarsier" ? Widget(props) : Password(props);
};

export default Main;
